import { RealworksTokenStatus, RealworksTokenType } from '~/graphql/types';
import type { RealworksTokenStatusFE } from '../apiStatusToVariant';

/** Backend returns this error when the office does not match in the inserted token */
const OFFICE_MISMATCH_ERROR = 'Office mismatch';

const text = {
  officeMismatchError:
    'Deze API moet bij dezelfde Realworks vestiging in deze koppeling horen.',
  skipped: 'Deze koppeling is overgeslagen',
  pending: 'De koppeling is in afwachting van goedkeuring.',
  error:
    'Er is iets misgegaan met het opzetten van de koppeling voor deze vestiging. Klik hieronder om het opnieuw te proberen.',
  agendaTokenWarning:
    'Let op! De agendakoppeling werkt alleen in combinatie met een actief relatietoken.',
};

const PENDING_STATUS_DESCRIPTION: Record<RealworksTokenType, string> = {
  [RealworksTokenType.Agenda]: `${text.pending} ${text.agendaTokenWarning}`,
  [RealworksTokenType.Relatie]: text.pending,
  [RealworksTokenType.Wonen]: text.pending,
};

const getErrorStatusDescription = (error?: string | null): string => {
  if (error && error === OFFICE_MISMATCH_ERROR) return text.officeMismatchError;
  return text.error;
};

const apiStatusToDescription = ({
  status,
  error,
  tokenType,
}: {
  status: RealworksTokenStatusFE | undefined;
  error?: string | null;
  tokenType: RealworksTokenType;
}): React.ReactNode => {
  switch (status) {
    case RealworksTokenStatus.Pending:
      return PENDING_STATUS_DESCRIPTION[tokenType] || text.pending;
    case RealworksTokenStatus.Error:
      return getErrorStatusDescription(error);
    case 'skipped':
      return text.skipped;
    case RealworksTokenStatus.Active:
    default:
      return null;
  }
};

export default apiStatusToDescription;
